import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import CategoryDropdown from './CategoryDropdown';
import FactoryDropdownMultiple from './FactoryDropdownMultiple';
import RoleDropdown from './RoleDropdown';
import SearchGrievanceUserDropdown from './SearchGrievanceUserDropdown';

const AddPermissionModal = ({ handleClose, show, onAdd }) => {
    const [groupMembers, setGroupMembers] = useState([]);
    // const [userID, setUserID] = useState('');
    // const [userName, setUserName] = useState('');
    const [selectfactory, setSelectFactory] = useState([]);
    const [selectCategory, setSelectCategory] = useState([]);
    const [selectRole, setSelectRole] = useState([]);
    const [createdBy, setCreatedBy] = useState('');
    const [theShow, setshow] = useState(show);
    
    useEffect(() => {
        setshow(show);
        setSelectRole([]);
        setGroupMembers([]);
        setCreatedBy(localStorage.getItem('badgeID'));
    }, [show]);

    const getFactory = (factoryProp) => {
        setSelectFactory(factoryProp);
    };

    const getCategory = (CategoryProp) => {
        setSelectCategory(CategoryProp);
    };

    const getRole = (RoleProp) => {
        setSelectRole(RoleProp);
    };

    const onSubmit = (e) => {
        e.preventDefault();

        if(groupMembers == ""){
            alert('Please enter a username');
        }
        else if(selectRole == ""){
            alert('Please select a role');
        }
        else if(selectRole == 1){
            if (selectCategory == "") {
                alert('Please select a category');
            }
            else{
                if(!window.confirm('Do you want to submit this?')) {
                    return false;
                }
                const factorylist = selectfactory.toString();
                const categorylist = selectCategory.toString();
                const userID = groupMembers.empId;
                const userName = groupMembers.formalName;
    
                onAdd({
                    userID,
                    userName,
                    factorylist,
                    categorylist,
                    selectRole,
                    createdBy
                });
            } 
        }
        else if (selectRole == 2){
            if(selectfactory == ""){
                alert('Please select a factory');
            }
            else{
                if(!window.confirm('Do you want to submit this?')) {
                    return false;
                }
                const factorylist = selectfactory.toString();
                const categorylist = selectCategory.toString();
                const userID = groupMembers.empId;
                const userName = groupMembers.formalName;
    
                onAdd({
                    userID,
                    userName,
                    factorylist,
                    categorylist,
                    selectRole,
                    createdBy
                });
            }
        } else {
            if(!window.confirm('Do you want to submit this?')) {
                return false;
            }
            const factorylist = selectfactory.toString();
            const categorylist = selectCategory.toString();
            const userID = groupMembers.empId;
            const userName = groupMembers.formalName;

            onAdd({
                userID,
                userName,
                factorylist,
                categorylist,
                selectRole,
                createdBy
            });
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header>
                <Modal.Title style={{ marginBottom: '0px' }}>
                    Add User Permission
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form 
                onSubmit={onSubmit}
                >   
                    <Form.Group className='mb-3'>
                        <Form.Label>Name</Form.Label>
                        <SearchGrievanceUserDropdown setGroupMembers={setGroupMembers}/>
                        {/* <Form.Control
                            type='text'
                            placeholder='Insert the user name here...'
                            style={{ width: '100%' }}
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                        /> */}
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Badge ID</Form.Label>
                        <Form.Control
                            readOnly
                            type='text'
                            placeholder='Autofill based on name'
                            style={{ width: '100%' }}
                            value={groupMembers.empId}
                            // onChange={(e) => setUserID(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className='mb-3'>
                        <Form.Label>Role</Form.Label>
                        <RoleDropdown
                        getRole={getRole}
                        />
                    </Form.Group>
                    {selectRole == 2 && <Form.Group className='mb-3'>
                        <Form.Label>Factory</Form.Label>
                        <FactoryDropdownMultiple
                        getFactory={getFactory}
                        />
                    </Form.Group>}
                    {selectRole == 1 && <Form.Group className='mb-3'>
                        <Form.Label>Category</Form.Label>
                        <CategoryDropdown
                        getCategory={getCategory}
                        />
                    </Form.Group>}
                    {selectRole == 4 && <Form.Group className='mb-3'>
                        <Form.Label>Category</Form.Label>
                        <CategoryDropdown
                        getCategory={getCategory}
                        />
                    </Form.Group>}
                    {selectRole == 5 && <Form.Group className='mb-3'>
                        <Form.Label>Category</Form.Label>
                        <CategoryDropdown
                        getCategory={getCategory}
                        />
                    </Form.Group>}
                    <Button as='input' type='submit' value='Add' />
                    <Button variant='outline-secondary' onClick={handleClose}>
                        Close
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default AddPermissionModal;
